import React from 'react';
import Header from './Header';
import './HeaderWrapper.css';

const HeaderWrapper = ({ onLogin, onRegister }) => {
  return (
    <div className="header-wrapper">
      <Header onLogin={onLogin} onRegister={onRegister} />
    </div>
  );
};

export default HeaderWrapper;
